import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { KioskOrderType } from '@ordering/gql/graphql';
import { useRouter, useSearchParams } from 'next/navigation';
import { useSetOrderType } from '@ordering/stores/OrderStore/hooks';
import { CollectionPoint } from '@ordering/types/Order';
export const useCollectionPointFromUrl = t0 => {
  const $ = _c(8);
  const {
    orderTypes,
    setOrderType
  } = t0;
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams.get("cpt");
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const collectionPoint = t1;
  const router = useRouter();
  let t2;
  let t3;
  if ($[2] !== collectionPoint || $[3] !== orderTypes || $[4] !== router || $[5] !== setOrderType) {
    t2 = () => {
      if (!collectionPoint) {
        return;
      }
      orderTypes.forEach(orderType => {
        const collectionPoints = orderType.collectionPoints;
        const collectionPointSelected = collectionPoints.find(point => point.id === collectionPoint);
        if (collectionPointSelected) {
          setOrderType(orderType, collectionPointSelected);
          router.push("menu");
        }
      });
    };
    t3 = [collectionPoint, orderTypes, router, setOrderType];
    $[2] = collectionPoint;
    $[3] = orderTypes;
    $[4] = router;
    $[5] = setOrderType;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
};